<template>
  <div id="app">
    <component v-bind:is="layout"></component>
  </div>
</template>

<script>
import DefaultLayout from './layouts/Default'
import LoginLayout from './layouts/Login'

export default {
  computed: {
    layout () {
      return this.$store.getters.layout
    }
  },
  components: {
    DefaultLayout,
    LoginLayout
  },
  mounted() {
    this.$store.dispatch('auth/fetchUser')
    this.$store.dispatch('pages/getLanguages')
  }
}

</script>

<style lang="scss">
  @import "@/assets/scss/app.scss";

</style>
